module.exports = __webpack_public_path__ + "assets/bgPhone.2d5bb6395bfc6c106432cf3eeaf16884.jpg";